/* tslint:disable */
/* eslint-disable */
/**
 * MEP campaigns
 * API for retrieving campaign information.
 *
 * The version of the OpenAPI document: _
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Campaign
 */
export interface Campaign {
    /**
     * Code of the campaign for sending back to backend.
     * @type {string}
     * @memberof Campaign
     */
    campaignCode?: string;
    /**
     * Name of the campaign.
     * @type {string}
     * @memberof Campaign
     */
    name?: string;
    /**
     * Name of the function job managers have when they are part of this campaign.
     * @type {string}
     * @memberof Campaign
     */
    contactsFunction?: string;
    /**
     * Url to the background image for the campaign.
     * @type {string}
     * @memberof Campaign
     */
    pictureUrl?: string;
    /**
     * Url to the video for the campaign.
     * @type {string}
     * @memberof Campaign
     */
    videoUrl?: string;
    /**
     * Calendly Url.
     * @type {string}
     * @memberof Campaign
     */
    calendlyUrl?: string;
}

export function CampaignFromJSON(json: any): Campaign {
    return CampaignFromJSONTyped(json, false);
}

export function CampaignFromJSONTyped(json: any, ignoreDiscriminator: boolean): Campaign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'campaignCode': !exists(json, 'campaignCode') ? undefined : json['campaignCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'contactsFunction': !exists(json, 'contactsFunction') ? undefined : json['contactsFunction'],
        'pictureUrl': !exists(json, 'pictureUrl') ? undefined : json['pictureUrl'],
        'videoUrl': !exists(json, 'videoUrl') ? undefined : json['videoUrl'],
        'calendlyUrl': !exists(json, 'calendlyUrl') ? undefined : json['calendlyUrl'],
    };
}

export function CampaignToJSON(value?: Campaign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'campaignCode': value.campaignCode,
        'name': value.name,
        'contactsFunction': value.contactsFunction,
        'pictureUrl': value.pictureUrl,
        'videoUrl': value.videoUrl,
        'calendlyUrl': value.calendlyUrl,
    };
}

